<div class="extra-results-display">
  <div
    *ngIf="
      dcdResultsExpanded &&
      pricedLeg?.dcdResults?.priceDepositCurrency !== null &&
      pricedLeg?.dcdResults?.priceDepositCurrency !== undefined &&
      pricedLeg?.dcdResults?.priceDepositCurrency !== ''
    "
    class="results-row"
    [ngClass]="{ 'results-row--end': pricedLeg?.pricing?.headers?.ask }"
  >
    {{ depositCurrency }}
    {{ pricedLeg?.dcdResults?.priceDepositCurrency | number: '1.0-0' }}
  </div>

  <!-- marginInAlternativeCurrency -->
  <div
    *ngIf="
      dcdResultsExpanded &&
      pricedLeg?.dcdResults?.priceAlternativeCurrency !== null &&
      pricedLeg?.dcdResults?.priceAlternativeCurrency !== undefined &&
      pricedLeg?.dcdResults?.priceAlternativeCurrency !== '' &&
      isRowEnabled('marginInAlternativeCurrency')
    "
    class="results-row"
    [ngClass]="{ 'results-row--end': pricedLeg?.pricing?.headers?.ask }"
  >
    {{ alternativeCurrency }}
    {{ pricedLeg?.dcdResults?.priceAlternativeCurrency | number: '1.0-0' }}
  </div>

  <!-- optionNotional -->
  <div
    *ngIf="dcdResultsExpanded && isRowEnabled('optionNotional')"
    class="results-row"
    [ngClass]="{ 'results-row--end': pricedLeg?.pricing?.headers?.ask }"
  >
    {{ pricedLeg?.dcdResults?.optionNotionalCurrency }}
    {{ pricedLeg?.dcdResults?.optionNotional | number: '1.0-0' }}
  </div>

  <!-- exerciseProbability -->
  <div
    *ngIf="dcdResultsExpanded && isRowEnabled('exerciseProbability')"
    class="results-row"
    [ngClass]="{ 'results-row--end': pricedLeg?.pricing?.headers?.ask }"
  >
    {{ pricedLeg?.dcdResults?.exerciseProba | percent: '1.2-2' }}
  </div>

  <!-- interestConvention -->
  <div
    *ngIf="dcdResultsExpanded && isRowEnabled('interestConvention')"
    class="results-row"
    [ngClass]="{ 'results-row--end': pricedLeg?.pricing?.headers?.ask }"
  >
    {{ pricedLeg?.dcdResults?.interestConvention }}
  </div>
</div>
